import { Component, computed, effect, inject, input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FileManagerService } from '../../../services/file-manager.service';
import type { QuotaResponse } from '../../../models/api';

@Component({
    selector: 'app-file-manager-quota',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './file-manager-quota.component.html',
    styleUrl: './file-manager-quota.component.scss'
})
export class FileManagerQuota {
    private readonly api = inject(FileManagerService);

    storage = input<string>('');
    refreshTrigger = input<number>(0);

    private quota = signal<QuotaResponse | null>(null);

    usedLabel = computed(() => this.formatBytes(this.quota()?.used_bytes));
    totalLabel = computed(() => this.formatBytes(this.quota()?.limit_bytes));
    percent = computed(() => {
        const p = this.quota()?.percentage ?? 0;
        return Math.round(p * 10) / 10;
    });
    progressWidth = computed(() => `${this.percent()}%`);

    constructor() {
        effect(() => {
            const storage = this.storage();
            this.refreshTrigger();
            if (!storage) return;
            this.api.getFileSystemQuota(storage).subscribe({
                next: (data) => this.quota.set(data),
                error: (err) => console.error('Failed to load quota:', err),
            });
        });
    }

    private formatBytes(bytes?: number): string {
        if (bytes == null) return '-';
        if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(0)} Kb`;
        if (bytes < 1024 * 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} Mb`;
        return `${(bytes / (1024 * 1024 * 1024)).toFixed(2)} Gb`;
    }
}
